import Page from '../../components/Page';
import React from 'react';
import {Card, CardBody, CardHeader, Col, Row, Table} from 'reactstrap';
import {Link} from "react-router-dom";
import {MdEdit, MdVisibility, MdAdd} from "react-icons/lib/md";
import API from "../../resources/index";

class ManagerPage extends React.Component {
    managerResource = API.managerResource;

    constructor() {
        super();
        this.state = {
            managers: []
        }
    }

    componentDidMount() {
        this.managerResource.query({keys: {expand: ['auth']}})
            .then(response => {
                if (response.status === 200)
                    this.setState({managers: response.data});
            })
    }

    render() {
        return <Page
            title="Gestores"
            icon='MdGroup'
            // breadcrumbs={[{name: 'gestores', active: true}]}
            className="">
            <Row>
                <Col>
                    <Card className="mb-3">
                        <CardHeader>
                            <h4 className='float-left table-title mt-1'>Gestores Cadastrados</h4>
                            <Link className='btn btn-secondary float-right' to="/managers/form"><MdAdd/> Novo
                                Gestor</Link>
                        </CardHeader>
                        <CardBody>
                            <Table responsive>
                                <thead>
                                <tr>
                                    <th>Nome</th>
                                    <th>E-mail</th>
                                    <th>Status</th>
                                    <th>Ações</th>
                                </tr>
                                </thead>
                                <tbody>
                                {this.state.managers.map(manager => {
                                    return <tr key={manager.id}>
                                        <td>{manager.name}</td>
                                        <td>{manager.auth && manager.auth.email}</td>
                                        <td>{manager.is_activated ? 'Sim' : 'Não'}</td>
                                        <td>
                                            <Link className='btn btn-outline-secondary mr-2'
                                                  to={`/managers/detail/${manager.id}`}>
                                                <MdVisibility/> Ver
                                            </Link>

                                            <Link className='btn btn-outline-secondary'
                                                  to={`/managers/form/${manager.id}`}>
                                                <MdEdit/> Editar
                                            </Link>
                                        </td>
                                    </tr>
                                })}

                                {!this.state.managers.length && <tr>
                                    <td colSpan={4} style={{textAlign: 'center'}}>Não há itens para exibição</td>
                                </tr>}
                                </tbody>
                            </Table>
                        </CardBody>
                    </Card>
                </Col>
            </Row>

        </Page>
    };
}

export default ManagerPage;



// WEBPACK FOOTER //
// ./src/pages/manager/ManagerPage.js